import { render } from "./PageCommands.vue?vue&type=template&id=822fe464&scoped=true"
import script from "./PageCommands.vue?vue&type=script&lang=js"
export * from "./PageCommands.vue?vue&type=script&lang=js"

import "./PageCommands.vue?vue&type=style&index=0&id=822fe464&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-822fe464"]])

export default __exports__